import React from 'react';
import classNames from 'classnames';

import { PlatformBadge } from '../../../../components/PlatformBadge';
import {
  isIOS,
  isAndroidChrome,
} from '../../../../../helpers/serverRenderingUtils';

import { AppStoreDownloadButton } from '../../../QuicksilverAppScreen/components/AppStoreDownloadButton';
import { AppStoreButton } from '../../../../components/AppDownloadButtons';

import styles from './styles.sass';

const AppButtons = ({
  clickEventLocation,
  clickEventSection,
  appStoreUrl,
  playStoreUrl,
  mobileAppStoreUrl,
  mobilePlayStoreUrl,
}) => {
  const mobileButtons = (
    <AppStoreDownloadButton
      white
      width={162}
      clickEventLocation={clickEventLocation}
      clickEventSection={clickEventSection}
      appStoreUrl={mobileAppStoreUrl || appStoreUrl}
      playStoreUrl={mobilePlayStoreUrl || playStoreUrl}
    />
  );
  const desktopButtons = (
    <React.Fragment>
      <div className={styles.desktopAppStoreOnly}>
        <AppStoreButton white />
      </div>
      <div className={styles.desktopAllPlatform}>
        <PlatformBadge
          url={appStoreUrl}
          platformName="apple"
          clickEventLocation={clickEventLocation}
          clickEventSection={clickEventSection}
        />
        <PlatformBadge
          url={playStoreUrl}
          platformName="google"
          clickEventLocation={clickEventLocation}
          clickEventSection={clickEventSection}
        />
      </div>
    </React.Fragment>
  );
  const isMobile = isIOS() || isAndroidChrome();
  return (
    <div
      className={classNames(styles.appButtonContainer, {
        [styles.desktopAppButtonContainer]: !isMobile,
      })}
    >
      {isMobile ? mobileButtons : desktopButtons}
    </div>
  );
};

export { AppButtons };
